import { Button, Card, CardActions, CardContent, CardMedia, Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { LinkedIn, Pinterest, YouTube } from '@material-ui/icons';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Rahul from '../assets/coach/rahul.webp';
import Sanjay from '../assets/featurePanel/Sanjay.jpg';
import SysdesignPng from '../assets/featurePanel/sysdesign.png';
import LetsConnectModal from '../Components/TrackDetails/LetsConnectModal';

const aboutUsPageData = {
    title: 'About Us',
    description: `InterviewHelp.io is a coaching platform that helps people grow into top-tier organizations. 
    We currently focus on three domains Technical program managers, Software development managers and Software Development Engineers. 
    To support these three domains end to end, we offer various services ranging from resume reviews to placement support. 
    We consider ourselves a one-stop-shop in your journey to a new job or career.`,
    team: [
        {
            Name: 'Rahul Salota',
            Designation: 'Founder',
            image: Rahul,
            Bio: `Rahul Salota is a technologist and an entrepreneur with 20+ years of experience.
                He has a passion for growing people to their fullest potential. 
                Interviewhelp.io was built with a vision to metrisize the impact of personalized coaching in people's lives.`,
            Links: {
                linkedIn: 'https://www.linkedin.com/in/rsalota',
                pinterest: '#',
                youtube: '#'
            }
        },
        {
            Name: 'Sanjay Gupta',
            Designation: '',
            image: Sanjay,
            Bio: `Sanjay Gupta is a seasoned professional with over 25 years of experience in the field of Information Technology. 
                He has a strong background in project management, product development and execution with a focus on delivering complex, 
                large-scale IT projects on time and within budget.
                <br /> <br />
                Sanjay has a proven track record of success in leading cross-functional teams and driving results in fast-paced, dynamic environments. 
                He has excellent communication and interpersonal skills, and is adept at building relationships with key stakeholders and clients.
                <br /> <br />
                Throughout his career, Sanjay has worked in a variety of industries, including Compliance, Publication, Travel, Telecommunication and Retail. 
                He has held leadership roles at leading companies such as Microsoft, Expedia, Quark and T-Mobile`,
            Links: {
                linkedIn: 'https://www.linkedin.com/in/sanjay-gupta-0850102',
                pinterest: '#',
                youtube: '#'
            }
        },
        /**
            {
                Name: 'Priya',
                Designation: '',
                image: testImg,
                Bio: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent posuere accumsan sem, 
                porttitor congue lacus dictum ut. Vivamus sodales nibh ac massa facilisis ullamcorper. Nunc sed magna 
                vulputate, convallis nunc non, iaculis justo. Vestibulum feugiat hendrerit tortor vel venenatis.
                Nam placerat`,
                Links: {
                    linkedIn: 'https://linkedin.com/in/',
                    pinterest: 'https://in.pinterest.com/',
                    youtube: 'http://youtube.com/'
                }
            },
        */
    ],
    boardMembers: [
        /**
            {
                Name: 'Rahul Salota',
                Designation: 'Founder',
                image: testImg,
                Bio: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi quis nulla euismod, 
                gravida quam eget, pellentesque lorem. Nullam imperdiet pharetra imperdiet. Duis non bibendum ante,
                eleifend aliquet felis. Nam varius libero enim, sit amet scelerisque ligula pharetra id. 
                Nullam ut eros eu tellus elementum vehicula at sit amet dui. Fusce suscipit mi quis augue mattis, 
                et lacinia enim euismod. Etiam justo sem, posuere a libero vel, finibus ultrices ipsum.`,
                Links: {
                    linkedIn: 'https://linkedin.com/in/',
                    pinterest: 'https://in.pinterest.com/',
                    youtube: 'http://youtube.com/'
                }
            },
            {
                Name: 'Sanjay Gupta',
                Designation: '',
                image: testImg,
                Bio: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent posuere accumsan sem, 
                porttitor congue lacus dictum ut. Vivamus sodales nibh ac massa facilisis ullamcorper. Nunc sed magna 
                vulputate, convallis nunc non, iaculis justo. Vestibulum feugiat hendrerit tortor vel venenatis.
                Nam placerat`,
                Links: {
                    linkedIn: 'https://linkedin.com/in/',
                    pinterest: 'https://in.pinterest.com/',
                    youtube: 'http://youtube.com/'
                }
            },
            {
                Name: 'Priya',
                Designation: '',
                image: testImg,
                Bio: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent posuere accumsan sem, 
                porttitor congue lacus dictum ut. Vivamus sodales nibh ac massa facilisis ullamcorper. Nunc sed magna 
                vulputate, convallis nunc non, iaculis justo. Vestibulum feugiat hendrerit tortor vel venenatis.
                Nam placerat`,
                Links: {
                    linkedIn: 'https://linkedin.com/in/',
                    pinterest: 'https://in.pinterest.com/',
                    youtube: 'http://youtube.com/'
                }
            },
        */
    ],
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        marginTop: "92px",
        boxSizing: "border-box",
        "& .MuiTypography-root": {
            letterSpacing: "1px",
        },
    },
    banner: {
        '& .responsiveItemLeft': {
            '& img': {
                display: 'block',
                margin: 'auto',
                padding: '20px',
                height: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
            },
            [theme.breakpoints.down('sm')]: {
                margin: '0 !important',
                width: '100%',
                textAlign: 'left !important',
                '& img': {
                    height: '14rem'
                },
            }
        },
        '& .responsiveItemRight': {
            '& p': {
                padding: '10px'
            },
            [theme.breakpoints.down('sm')]: {
                margin: '0 !important',
            }
        }
    },
    teamMembers: {
        maxWidth: 345,
        marginBottom: 8
    },
    teamGrid: {
        justifyContent: 'space-around !important',
        marginBottom: '20px'
    },
    teamBody: {
        height: '200px',
        overflow: 'auto',
        padding: '3px',
        '&::-webkit-scrollbar': {
            width: '5px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
            borderRadius: '5px',
            background: '#707070',
        },
        '&:hover::-webkit-scrollbar-track': {
            borderRadius: '5px',
            boxShadow: 'inset 0 0 3px grey',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#8b8b8b',
        },
    },
    title: {
        marginBottom: '15px',
        height: 'min-content',
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        '& h1': {
            fontWeight: 'bold',
            borderBottom: '2px solid black',
            width: 'fit-content'
        }
    },
    icon: {
        width: '2rem !important',

    },
    motivational: {
        padding: '10px',
        textAlign: 'center',
        display: 'inline-flex',
        margin: '20px',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        "& .successBtn": {
            backgroundColor: '#E25252',
            borderRadius: '4px',
            boxShadow: 'none',
            height: '48px',
            marginTop: '18px',
            fontWeight: '600',
            fontSize: '18px',
            letterSpacing: '1px',
            textTransform: "uppercase",
            '&:hover': {
                background: '#D73C3C'
            },
            '&:active': {
                background: '#D33030',
                boxShadow: 'none'
            }
        }
    },
}));

export default () => {
    const classes = useStyles();
    const [modalOpen, stModalOpen] = useState(false)
    const { search } = useLocation();
    const [modalProperties] = useState({
        heading: '',
        btnText: '',
    })
    const enrollFreePlan = () => window.location.href = process.env.REACT_APP_EVAL_URL + `${search ? (search + '&') : '?'}lpflowtype=enroll`

    const getSocialIcon = (link, url) => {
        let socialIcon = '';

        switch (link) {
            case 'linkedIn':
                socialIcon = <a href={url} target="_blank" style={{ color: 'inherit' }}><LinkedIn className={classes.icon} /></a>
                break;
            case 'pinterest':
                socialIcon = <a href={url} style={{ color: 'inherit' }}><Pinterest className={classes.icon} /></a>
                break;
            case 'youtube':
                socialIcon = <a href={url} style={{ color: 'inherit' }}><YouTube className={classes.icon} /></a>
                break;

            default:
                break;
        }
        return <IconButton
            size='small'
            color="inherit"
        >
            {socialIcon}
        </IconButton>
    }

    const getCards = (title, detailedArray = []) => {
        return <Grid container className={classes.teamGrid}>
            <div className={classes.title}>
                <h1>{title}</h1>
            </div>
            {detailedArray.map(member => {
                return <Card className={classes.teamMembers}>
                    <CardMedia
                        component="img"
                        alt={member.Name}
                        height="250"
                        image={member.image}
                        title={member.Name}
                    />
                    <CardContent className={classes.teamMembers}>
                        <Typography gutterBottom variant="h5" component="h2">
                            {member.Name},{member.Designation}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p" className={classes.teamBody}
                            dangerouslySetInnerHTML={{ __html: member.Bio }}>
                        </Typography>
                    </CardContent>
                    <CardActions>
                        {Object.keys(member.Links).map(link => {
                            return getSocialIcon(link, member.Links[link])
                        })}
                    </CardActions>
                </Card>
            })}
        </Grid>
    }
    return (
        <div className={classes.root}>
            <Grid container>
                <div className={classes.title}>
                    <h1>{aboutUsPageData.title}</h1>
                </div>
                <Grid container className={classes.banner}>
                    <Grid item xs={12} sm={6} className="responsiveItemLeft">
                        <img src={SysdesignPng} alt='na' />
                    </Grid>
                    <Grid item xs={12} sm={6} className="responsiveItemRight">
                        <p>{aboutUsPageData.description}</p>
                    </Grid>
                </Grid>
                {!!aboutUsPageData.team && getCards('Team', aboutUsPageData.team)}
                {!!aboutUsPageData.boardMembers.length && getCards('Board Members', aboutUsPageData.boardMembers)}
                <div className={classes.motivational}>
                    <div>
                        <Button
                            component="button"
                            variant="contained"
                            disableRipple
                            onClick={() => stModalOpen(true)}
                            className={'successBtn'}
                        >
                            {'Connect with us for your SUCCESS!'}
                        </Button>
                    </div>
                </div>
            </Grid>
            <LetsConnectModal
                {...modalProperties}
                defaultComment={`I am looking to connect with you for more custom options.`}
                open={modalOpen}
                handleClose={() => stModalOpen(false)}
                enrollFreePlan={enrollFreePlan}
                customMsg={{
                    thankyouMsg: "Thank you for showing interest in InterviewHelp. We will get back to you as soon as possible.",
                    freePlanMsg: "We are happy to let you know that we have Freebies. Until we customize option for you why don't you try freebies."
                }}
            />
        </div>)
}